import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AppLoggingService } from '../common/services/AppLogging.service';
import { Router } from '@angular/router';
import { DataForAlertMessage } from '../common/models/alertScreen';
import { environment } from '../../environments/environment';



@Component({
  selector: 'app-alert-screen',
  templateUrl: './alert-screen.component.html',
  styleUrls: ['./alert-screen.component.css']
})
export class AlertScreenComponent implements OnInit {

  formattedErrorMessage: string;
  data = new DataForAlertMessage();
  constructor(private route: ActivatedRoute, private log: AppLoggingService, private router: Router) {
    this.formattedErrorMessage = '';
  }

  ngOnInit() {
    this.data = this.log.getErrorMessage();
    if (this.data == null) {
      this.data = new DataForAlertMessage();
      this.data.message = 'En uventet hendelse har oppstått. Vennligst ta kontakt med oss på epost, hei@embla.no';
      this.data.url = 'home';
      this.data.urlType = 1;
    }
  }

  redirectToEmbla() {
    if (this.data.urlType === 1) {
      this.router.navigate([this.data.url]);
    } else {
      window.location.href = this.data.url;
    }
  }

}



// WEBPACK FOOTER //
// D:/Projects/Embla/dev/shop.embla.no/client.shop.embla.no/src/app/alert-screen/alert-screen.component.ts